/**
 * The install guide of the international eSIM, shared by the catalog « tuto »
 * dialog and the line detail card. Same content as the beneficiary e-mail.
 */
export const TRAVEL_ESIM_PREREQUISITES = [
  'Un téléphone compatible eSIM, connecté au wifi pour l’installation.',
  'Le QR code de l’eSIM internationale, reçu par e-mail.',
];

export const TRAVEL_ESIM_INSTALL_STEPS = [
  {
    device: 'iPhone',
    steps:
      'Réglages → Données cellulaires → Ajouter une carte eSIM → Scanner le QR code.',
  },
  {
    device: 'Android (Samsung)',
    steps:
      'Paramètres → Connexions → Gestionnaire SIM → Ajouter une eSIM → Scanner le QR code.',
  },
];

export const TRAVEL_ESIM_SETUP_STEPS = [
  {
    device: 'iPhone',
    steps: [
      'Ligne par défaut pour Internet : Réglages → Données cellulaires → Données cellulaires, choisir l’eSIM internationale.',
      'Données à l’étranger : Réglages → Données cellulaires → l’eSIM internationale → activer « Données à l’étranger ».',
    ],
  },
  {
    device: 'Android (Samsung)',
    steps: [
      'Ligne par défaut pour Internet : Paramètres → Connexions → Gestionnaire SIM → « Cartes SIM préférées », choisir l’eSIM pour les données mobiles.',
      'Données à l’étranger : Paramètres → Connexions → Réseaux mobiles → activer « Données en itinérance ».',
    ],
  },
];

